import { render, staticRenderFns } from "./RatesAnnotations.vue?vue&type=template&id=8ae86c5e&scoped=true"
import script from "./RatesAnnotations.vue?vue&type=script&lang=js"
export * from "./RatesAnnotations.vue?vue&type=script&lang=js"
import style0 from "./RatesAnnotations.vue?vue&type=style&index=0&id=8ae86c5e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae86c5e",
  null
  
)

export default component.exports